import getLoginType from "../utils/loginConfig";

export const testNavOptions = [
  {
    title: "Inscripción a nuevo examen",
    link: "/nueva-inscripcion",
    val: (userInfo) => !userInfo.lcci_redirect_to_finish,
  },
  { title: "Mis exámenes", link: "/mis-examenes" },
];
export const entityNavOptions = [
  {
    title: "MIFID",
    val: (userInfo) =>
      userInfo.access_preinscriptions || userInfo.access_reubication,
    options: [
      {
        val: (userInfo) => userInfo.access_preinscriptions,
        link: "/entidades/preinscripcion-de-candidatos",
        text: "Preinscripción a nuevos candidatos",
      },
      {
        val: (userInfo) => userInfo.access_reubication,
        link: "/entidades/panel-reubicacion",
        text: "Panel de reubicación, bajas y resultados",
      },
    ],
  },
  {
    title: "LCCI",
    val: (userInfo) =>
      userInfo.access_preinscriptions_lcci || userInfo.access_reubication_lcci,
    options: [
      {
        val: (userInfo) => userInfo.access_preinscriptions_lcci,
        link: "/entidades/preinscripcion-de-candidatos-lcci",
        text: "Preinscripción a nuevos candidatos LCCI",
      },
      {
        val: (userInfo) => userInfo.access_reubication_lcci,
        link: "/entidades/panel-reubicacion-lcci",
        text: "Panel de reubicación, bajas y resultados LCCI",
      },
    ],
  },
    {
    title: "Formación Continua",
    val: (userInfo) =>
      userInfo.access_preinscriptions_fc_mifid || userInfo.access_preinscriptions_fc_lcci,
    options: [
      {
        val: (userInfo) => userInfo.access_preinscriptions_fc_mifid,
        link: "/entidades/preinscripcion-formacion-continua-mifid",
        text: "Preinscripción a la Formación Continua MIFID",
      },
      {
        val: (userInfo) => userInfo.access_preinscriptions_fc_lcci,
        link: "/entidades/preinscripcion-formacion-continua-lcci",
        text: "Preinscripción a la Formación Continua LCCI",
      },
    ],
  },
  {
    title: "Seguimiento horas de formación",
    link: "/entidades/seguimiento",
    val: (userInfo) => userInfo.access_tracing,
  },
  {
    title: "Envío y recepción de documentos",
    link: "/entidades/documentacion",
    val: (userInfo) => userInfo.access_documentation,
  },
  {
    title: "Datos de acceso",
    link: "/entidades/modificar-datos-acceso/",
  },
];

export const navbarOptionsByLogin = {
  entities: entityNavOptions,
  test: testNavOptions,
};

export const getNavOptionsByLogin = () => {
  const loginType = getLoginType();
  return navbarOptionsByLogin[loginType.name] || [];
};
